import * as THREE from 'three';
import { Config } from '../../core/Config';

export class LightManager {
  private directionalLight: THREE.DirectionalLight;
  private ambientLight: THREE.AmbientLight;
  
  constructor(scene: THREE.Scene) {
    // Create directional light (sun)
    this.directionalLight = new THREE.DirectionalLight(
      Config.DIRECTIONAL_LIGHT_COLOR,
      Config.DIRECTIONAL_LIGHT_INTENSITY
    );
    this.directionalLight.position.set(50, 50, 50);
    this.directionalLight.castShadow = true;
    
    // Configure shadow properties using Config settings
    this.directionalLight.shadow.mapSize.width = Config.SHADOW_MAP_SIZE;
    this.directionalLight.shadow.mapSize.height = Config.SHADOW_MAP_SIZE;
    this.directionalLight.shadow.camera.near = 0.5;
    this.directionalLight.shadow.camera.far = 500;
    
    // Use the shadow camera size from Config
    const shadowSize = Config.SHADOW_CAMERA_SIZE;
    this.directionalLight.shadow.camera.left = -shadowSize;
    this.directionalLight.shadow.camera.right = shadowSize;
    this.directionalLight.shadow.camera.top = shadowSize;
    this.directionalLight.shadow.camera.bottom = -shadowSize;
    
    // Improve shadow quality
    this.directionalLight.shadow.bias = -0.0005;
    
    // Create ambient light
    this.ambientLight = new THREE.AmbientLight(
      Config.AMBIENT_LIGHT_COLOR,
      Config.AMBIENT_LIGHT_INTENSITY
    );
    
    // Add lights to scene
    scene.add(this.directionalLight);
    scene.add(this.ambientLight);
    
    console.log('Light Manager initialized');
  }
  
  public update(deltaTime: number): void {
    // Could add sun movement here if needed
  }
}
